<main class="reference_main">
  <div class="pink_box"></div>
  <div class="green_box"></div>
  <div class="main_dashbord" style="display: none;">
    <div class="information_cards-container">
      <div class="card_informarion">
        <h3 class="card_title purple">Total Employees</h3>
        <h3 class="card_stats">25,000</h3>
      </div>
      <div class="card_informarion">
        <h3 class="card_title teal">Total Departments</h3>
        <h3 class="card_stats">25,000</h3>
      </div>
      <div class="card_informarion">
        <h3 class="card_title navy">Total Employees</h3>
        <h3 class="card_stats">25,000</h3>
      </div>
      <div class="card_informarion">
        <h3 class="card_title orange_signal">Total Employees</h3>
        <h3 class="card_stats">25,000</h3>
      </div>
    </div>

    <div class="other_dashboard-contents">
      <div class="calendar">
        <img src="images/calendar.png" alt="" />
      </div>
      <div class="attendance_graph">
        <img src="images/attendance_graph.png" alt="" />
      </div>

      <div class="mini_card">
        <div class="the_card peaches">
          <p class="information">Requests<span class="total_no">9</span></p>
        </div>

        <div class="the_card green_card">
          <p class="information">Leave<span class="total_no">9</span></p>
        </div>

        <div class="the_card blue_card">
          <p class="information">Memo<span class="total_no">9</span></p>
        </div>
      </div>

      <div class="dash_project-card">
        <div class="brief_project">
          <h3 class="mini_card_title">Projects</h3>
          <div class="mini_project-card">
            <p>Total<span>5</span></p>

            <button class="see">See all</button>
          </div>
        </div>

        <div class="briefing_table">
          <div class="briefing_row">
            <span class="the_brief">Title</span>
            <span class="the_brief">Team</span>
            <span class="the_brief">Start</span>
            <span class="the_brief">Deadline</span>
            <span class="the_brief">Progress</span>
          </div>
          <div class="briefing_row">
            <span class="the_brief">Build a landing page</span>
            <span class="the_brief">5 members</span>
            <span class="the_brief">24/02/2020</span>
            <span class="the_brief">May 2021</span>
            <div class="the_brief">
              <span class="percentile">45%</span>
              <div class="progress_bar"><span class="color_bar"></span></div>
            </div>
          </div>
          <div class="briefing_row">
            <span class="the_brief">Build a landing page</span>
            <span class="the_brief">5 members</span>
            <span class="the_brief">24/02/2020</span>
            <span class="the_brief">May 2021</span>
            <div class="the_brief">
              <span class="percentile">45%</span>
              <div class="progress_bar"><span class="color_bar"></span></div>
            </div>
          </div>
          <div class="briefing_row">
            <span class="the_brief">Build a landing page</span>
            <span class="the_brief">5 members</span>
            <span class="the_brief">24/02/2020</span>
            <span class="the_brief">May 2021</span>
            <div class="the_brief">
              <span class="percentile">45%</span>
              <div class="progress_bar"><span class="color_bar"></span></div>
            </div>
          </div>
          <div class="briefing_row">
            <span class="the_brief">Build a landing page</span>
            <span class="the_brief">5 members</span>
            <span class="the_brief">24/02/2020</span>
            <span class="the_brief">May 2021</span>
            <div class="the_brief">
              <span class="percentile">45%</span>
              <div class="progress_bar"><span class="color_bar"></span></div>
            </div>
          </div>
          <div class="briefing_row">
            <span class="the_brief">Build a landing page</span>
            <span class="the_brief">5 members</span>
            <span class="the_brief">24/02/2020</span>
            <span class="the_brief">May 2021</span>
            <div class="the_brief">
              <span class="percentile">45%</span>
              <div class="progress_bar"><span class="color_bar"></span></div>
            </div>
          </div>
          <div class="briefing_row">
            <span class="the_brief">Build a landing page</span>
            <span class="the_brief">5 members</span>
            <span class="the_brief">24/02/2020</span>
            <span class="the_brief">May 2021</span>
            <div class="the_brief">
              <span class="percentile">45%</span>
              <div class="progress_bar"><span class="color_bar"></span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="meeting_card">
        <h3 class="card_heading">Meetings</h3>

        <div class="card_table">
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
          <div class="card_row">
            <span class="meeting_detail">Zoom meeting with Dangote</span>
            <span class="meet_date">Today</span>
            <span class="meet_time">02:34PM</span>
          </div>
        </div>
      </div>

      <div class="appraisal_card">
        <div class="card_topper">Appraisal <button class="see">See all</button></div>
        <div class="appraisal_table">
          <div class="appraisal_preview-row">
            <span class="preview_data">S/n</span>
            <span class="preview_data">Staff</span>
            <span class="preview_data">Job title</span>
            <span class="preview_data">Department</span>
            <span class="preview_data">Year of review</span>
          </div>
          <div class="appraisal_preview-row">
            <span class="preview_data">1.</span>
            <span class="preview_data">Onoriode Godbless</span>
            <span class="preview_data">Programming</span>
            <span class="preview_data">Sofware Development</span>
            <span class="preview_data">2019</span>
          </div>
          <div class="appraisal_preview-row">
            <span class="preview_data">1.</span>
            <span class="preview_data">Onoriode Godbless</span>
            <span class="preview_data">Programming</span>
            <span class="preview_data">Sofware Development</span>
            <span class="preview_data">2019</span>
          </div>
          <div class="appraisal_preview-row">
            <span class="preview_data">1.</span>
            <span class="preview_data">Onoriode Godbless</span>
            <span class="preview_data">Programming</span>
            <span class="preview_data">Sofware Development</span>
            <span class="preview_data">2019</span>
          </div>
          <div class="appraisal_preview-row">
            <span class="preview_data">1.</span>
            <span class="preview_data">Onoriode Godbless</span>
            <span class="preview_data">Programming</span>
            <span class="preview_data">Sofware Development</span>
            <span class="preview_data">2019</span>
          </div>
        </div>
      </div>

      <div class="travel_card">
        <div class="card_topper">Travel <button class="see">See all</button></div>
        <div class="travel_table">
          <div class="travel_preview-row">
            <span class="preview_data">Means of Transport</span>
            <span class="preview_data">Date</span>
            <span class="preview_data">Time</span>
            <span class="preview_data">Location</span>
            <span class="preview_data">Destination</span>
            <span class="preview_data"></span>
          </div>
          <div class="travel_preview-row">
            <span class="preview_data">Air</span>
            <span class="preview_data">25/03/2020</span>
            <span class="preview_data">10:00 Am</span>
            <span class="preview_data">Portharcourt</span>
            <span class="preview_data">Lagos</span>
            <span class="preview_data">5 persons</span>
          </div>
          <div class="travel_preview-row">
            <span class="preview_data">Air</span>
            <span class="preview_data">25/03/2020</span>
            <span class="preview_data">10:00 Am</span>
            <span class="preview_data">Portharcourt</span>
            <span class="preview_data">Lagos</span>
            <span class="preview_data">5 persons</span>
          </div>
          <div class="travel_preview-row">
            <span class="preview_data">Air</span>
            <span class="preview_data">25/03/2020</span>
            <span class="preview_data">10:00 Am</span>
            <span class="preview_data">Portharcourt</span>
            <span class="preview_data">Lagos</span>
            <span class="preview_data">5 persons</span>
          </div>
          <div class="travel_preview-row">
            <span class="preview_data">Air</span>
            <span class="preview_data">25/03/2020</span>
            <span class="preview_data">10:00 Am</span>
            <span class="preview_data">Portharcourt</span>
            <span class="preview_data">Lagos</span>
            <span class="preview_data">5 persons</span>
          </div>
        </div>
      </div>

      <div class="Incident_report-card">
        <div class="card_topper">Incident Report <button class="see">See all</button></div>
        <div class="incident_rep_table">
          <div class="incident_rep_preview-row">
            <span class="preview_data">Date</span>
            <span class="preview_data">Observed by</span>
            <span class="preview_data">Location</span>
            <span class="preview_data">Client</span>
          </div>
          <div class="incident_rep_preview-row">
            <span class="preview_data">10/10/10</span>
            <span class="preview_data">Kariebi Akpeki Annie</span>
            <span class="preview_data">Rivers</span>
            <span class="preview_data">Shell Cooperation</span>
          </div>
          <div class="incident_rep_preview-row">
            <span class="preview_data">10/10/10</span>
            <span class="preview_data">Kariebi Akpeki Annie</span>
            <span class="preview_data">Rivers</span>
            <span class="preview_data">Shell Cooperation</span>
          </div>
          <div class="incident_rep_preview-row">
            <span class="preview_data">10/10/10</span>
            <span class="preview_data">Kariebi Akpeki Annie</span>
            <span class="preview_data">Rivers</span>
            <span class="preview_data">Shell Cooperation</span>
          </div>
          <div class="incident_rep_preview-row">
            <span class="preview_data">10/10/10</span>
            <span class="preview_data">Kariebi Akpeki Annie</span>
            <span class="preview_data">Rivers</span>
            <span class="preview_data">Shell Cooperation</span>
          </div>
        </div>
      </div>

      <div class="bookings_preview-card">
        <div class="card_topper">Bookings <button class="see">See all</button></div>
        <div class="booking_table">
          <div class="booking_preview-row">
            <span class="preview_data">Visitors' Name</span>
            <span class="preview_data">Phone Number</span>
            <span class="preview_data">Date</span>
            <span class="preview_data">Time</span>
            <span class="preview_data">Purpose</span>
          </div>
          <div class="booking_preview-row">
            <span class="preview_data">John Doe Jacobson</span>
            <span class="preview_data">09062537917</span>
            <span class="preview_data">10/10/10</span>
            <span class="preview_data">3:00 pm</span>
            <span class="preview_data">official</span>
          </div>
          <div class="booking_preview-row">
            <span class="preview_data">John Doe Jacobson</span>
            <span class="preview_data">09062537917</span>
            <span class="preview_data">10/10/10</span>
            <span class="preview_data">3:00 pm</span>
            <span class="preview_data">official</span>
          </div>
          <div class="booking_preview-row">
            <span class="preview_data">John Doe Jacobson</span>
            <span class="preview_data">09062537917</span>
            <span class="preview_data">10/10/10</span>
            <span class="preview_data">3:00 pm</span>
            <span class="preview_data">official</span>
          </div>
          <div class="booking_preview-row">
            <span class="preview_data">John Doe Jacobson</span>
            <span class="preview_data">09062537917</span>
            <span class="preview_data">10/10/10</span>
            <span class="preview_data">3:00 pm</span>
            <span class="preview_data">official</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
